module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('bar-top')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cac1ac24"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home.vue
// module id = 720
// module chunks = 1